import TemplateNames from '../email-messages/TemplateNames';

export default {
  template_names: TemplateNames,
  email_messages_page_title: 'Email Messages',
  labels: {
    view_full_message: 'View full message',
    status: 'Status:',
    on: 'On',
    off: 'Off',
    next_send: 'Next send: {{date}}.',
  },
  descriptions: {
    welcome:
      'Sent once when a customer subscribes to your marketing emails, except sign-ups through your storefront form. A customer gets only one of Welcome, Welcome members club and Launch deal.',
    welcome_members_club:
      'Sent once when someone signs up through your storefront form and no sign-up promo code is set up, or joins your VIP members list. A customer gets only one of Welcome, Welcome members club and Launch deal.',
    storefront_promo:
      'Sent once when someone signs up through your storefront form while a sign-up promo code is set up. The email carries their personal promo code.',
    launch_deal:
      'Sent once to your imported customers, 30 minutes after your restaurant goes live. Customers who already got Welcome or Welcome members club are skipped.',
    we_miss_you:
      'Sent to subscribers whose last order was more than 45 days ago. Checked every morning; a customer gets it at most once every 45 days.',
    happy_friday:
      'Sent to all subscribers at 08:00 UTC on the first Friday of every even month (February, April, June, August, October, December).',
    lazy_sunday:
      'Sent to all subscribers at 08:00 UTC on the first Sunday of every odd month (January, March, May, July, September, November).',
    loyalty_program:
      "Sent when a customer's cashback balance reaches the minimum they can spend. A customer gets it at most once every 30 days.",
    you_might_also_like:
      'Sent 3 days after an order with at least 2 of the same item priced 6.00 or more, recommending one of your most popular items. A customer gets it at most once every 30 days.',
  },
  tiles: {
    sends_count: 'Messages Sent',
    delivery_rate: 'Delivery Rate',
    delivered_suffix: 'delivered',
    open_rate: 'Open Rate',
    opened_suffix: 'opened',
    click_rate: 'Click Rate',
    clicked_suffix: 'clicked',
    spam_report_rate: 'Spam Report Rate',
    spam_reports_suffix: 'reports',
    unsubscribe_rate: 'Unsubscribe Rate',
    unsubscribes_suffix: 'unsubscribes',
  },
  toasts: {
    failed_to_update_status: 'Failed to update status',
    failed_to_load_data: 'Failed to load data',
  },

  preview_modal: {
    title: 'Template Preview',
    labels: {
      subject: 'Subject:',
      close: 'Close',
    },
    toasts: {
      failed_to_load_data: 'Failed to to load preview data',
    },
    template_data: {
      recipient_name: '&lt;First name&gt;',
    },
  },
};
